import React from "react";

import logo_svg from "../../common/icons/svg/logo.svg";
import CustomSelect from "../CustomSelect/CustomSelect";
import "./HeaderDesktopView.scss";

const HeaderDesktopView = (props) => {
    return (
        <div className="header">
            <div className="logo-container">
                <img
                    className="logo"
                    src={logo_svg}
                    alt="logo svg"
                    onClick={() => console.log("logo clicked !!")}
                />
                <div className="dashboard-text">HorizonView</div>
            </div>

            <div className="ward-container">
                <div className="hospital-name-container">
                    {props.hospitalName}
                </div>
                <div className="select-container">
                    <CustomSelect
                        id="ward-name"
                        className="header-ward-select"
                        variant="header"
                        value={props.selectedWard}
                        handleChange={(item) => props.handleWardChange(item)}
                        label="label"
                        isClearable={false}
                        options={props?.wardOption || []}
                        placeholder="Select Ward"
                        backgroundColor="#333333"
                        isDisabled={props.isDisabled}
                        isSearchable={false}
                        singleValFontSize="0.80vw"
                        optionFontSize="0.729vw"
                        controlHeight="100%"
                    />
                </div>
            </div>
        </div>
    );
};

export default HeaderDesktopView;
